import React from "react";
import styled from "styled-components";
import { tokens } from "../../theme/tokens";

// Avatar — image or initials, in a branded circle. Presentation-only.
//
//   <Avatar name="Dennis Natalia" src={photoUrl} size={40} />

const { colors, typography } = tokens;

const sizes = { sm: 28, md: 40, lg: 56 };

const Root = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: ${(p) => p.$px}px;
    height: ${(p) => p.$px}px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    background: linear-gradient(135deg, ${colors.crimson}, ${colors.maroon});
    color: ${colors.onDark};
    font-family: ${typography.fonts.body};
    font-weight: ${typography.weight.bold};
    font-size: ${(p) => Math.round(p.$px * 0.4)}px;
    letter-spacing: 0.02em;
    user-select: none;
    box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.25);
    img { width: 100%; height: 100%; object-fit: cover; }
    svg { width: 58%; height: 58%; opacity: 0.92; }
`;

// Shown when there's no photo — a neutral person icon (no extra deps).
const PersonIcon = () => (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12 12a5 5 0 1 0-5-5 5 5 0 0 0 5 5zm0 2c-4.4 0-8 2.2-8 5v1h16v-1c0-2.8-3.6-5-8-5z" />
    </svg>
);

export default function Avatar({ name, src, size = "md", ...rest }) {
    const px = typeof size === "number" ? size : sizes[size] || sizes.md;
    return (
        <Root $px={px} title={name} {...rest}>
            {src ? <img src={src} alt={name || ""} /> : <PersonIcon />}
        </Root>
    );
}
